import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolvePageTitle } from "../../utils/pageTitleResolver";

export default function PageTitleManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = resolvePageTitle(pathname);
  }, [pathname]);

  return null;
}
